import { useCallback, useEffect, useState } from "react";
import { Users, Star, MessageCircle, CalendarClock, AlarmClock, CalendarCheck, Search, PoundSterling } from "lucide-react";
import { StatCard } from "@/components/common/StatCard";
import { api } from "@/lib/api";
import { gbp } from "@/data/investorOptions";

export const InvestorSummary = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => {
    try { setS(await api.list("investor-summary")); } catch { setS(null); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const cards = [
    { label: "Total Investors", value: s?.total ?? "—", icon: Users, tone: "royal" },
    { label: "Priority Targets", value: s?.priority_targets ?? "—", icon: Star, tone: "gold" },
    { label: "Active Conversations", value: s?.active_conversations ?? "—", icon: MessageCircle, tone: "royal" },
    { label: "Follow-ups Due", value: s?.followups_due ?? "—", icon: CalendarClock, tone: "cyan" },
    { label: "Overdue Follow-ups", value: s?.overdue_followups ?? "—", icon: AlarmClock, tone: "coral" },
    { label: "Meetings Scheduled", value: s?.meetings_scheduled ?? "—", icon: CalendarCheck, tone: "royal" },
    { label: "In Due Diligence", value: s?.due_diligence ?? "—", icon: Search, tone: "cyan" },
    { label: "Potential Value", value: s ? gbp(s.total_potential) : "—", icon: PoundSterling, hint: s ? `Weighted: ${gbp(s.weighted_potential)}` : undefined, tone: "gold" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="investor-summary">
      {cards.map((c, i) => <StatCard key={c.label} index={i} testid={`investor-stat-${i}`} {...c} />)}
    </div>
  );
};
